import { useState, useCallback } from 'react';
import { LoanSimulation } from '@src/shared/models';
import { setLoanSimulation, clearOptions } from '@src/shared/zustand';
import { useScrollHandler } from '@src/shared/hooks';
import { getDownPaymentPlusInstallment } from '@src/shared/utils';

type UseLoanSimulationViewProps = {
  customSelected: boolean;
  loanSimulation: LoanSimulation;
};

export const useLoanSimulationView = ({
  customSelected = false,
  loanSimulation,
}: UseLoanSimulationViewProps) => {
  const [isSelected, setIsSelected] = useState(customSelected);
  const { scrollToTop } = useScrollHandler();

  const selected = useCallback(() => {
    setLoanSimulation(loanSimulation);
    clearOptions();

    setIsSelected(true);
    scrollToTop();
  }, [loanSimulation, scrollToTop]);

  const downPaymentPlusInstallment =
    getDownPaymentPlusInstallment(loanSimulation);

  return {
    isSelected,
    selected,
    downPaymentPlusInstallment,
  };
};
